import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
}

const ServiceCard = ({ title, description, icon, link }: ServiceCardProps) => {
  return (
    <div className="bg-stone-100 rounded-lg shadow-md hover:shadow-xl transition-shadow p-6 flex flex-col h-full">
      <div className="bg-stone-800 text-stone-200 p-3 rounded-2xl w-16 h-16 flex items-center justify-center relative -top-10">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-stone-800 mb-3">{title}</h3>
      <p className="text-stone-600 mb-6 flex-grow">{description}</p>
    </div>
  );
};

export default ServiceCard;
